module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAM1BMVEUAAAApLzMpLzMpLzN5aj3/zE3/zE1NSTdNSTcpLzMpLzMpLzMpLzN7az3/zE2ZqrWZqrV27YStAAAAEXRSTlMAYL////+/YAAgzwDvz2D/AJllXAEAAAC8SURBVHgB7czNagQxDAThsjXajN2Tn/d/2jiwbA65LLgJCaiOLfFR/ddaj6+O/O6I1XPr7eVccZ5jxo6z1jkkNK5dJ+IaQnPbWU3RDM6q0S1OdDxOHJicxOQkJicxOYnJSUxOYnISk5OYnMTkJCYnMTkHJicwOYHJCUxOYHICkxOYnKB7nE6zONHQdDhTaFz7zjWENF53nTkktHq77Ti9aYXuvT/6eKKf3zxOfxoqqKCCCiqooIIM/TJU0Ce0W7yCpP/xXQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/devfest/1f6a7.png
// module id = 1281
// module chunks = 0